import { defineStore } from 'pinia';
import { auth } from '../firebase';
import {
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signOut,
    getAuth,
    createUserWithEmailAndPassword
} from 'firebase/auth';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        loading: true
    }),

    actions: {
        async login(email, password) {
            await signInWithEmailAndPassword(auth, email, password);
            this.fetchUser();

            if(this.user) {
                localStorage.setItem('auth_user_id', this.user.uid);
                localStorage.setItem('auth_user_token', await this.user.getIdToken());
            }
        },
        async registerUser(email, password, dob = null, first_name = null, last_name = null, plan = 'free') {
            try {
                const userCredential = await createUserWithEmailAndPassword(auth, email, password);
                const user = userCredential.user;

                // Get ID token (with custom claims if already set server-side)
                const idToken = await user.getIdToken();

                // Send token and metadata to your Cloudflare Worker
                const response = await fetch('https://dp.requestcatcher.com/register', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${idToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        first_name,
                        plan
                    })
                });

                const result = await response.json();
                console.log('Server response:', result);
            } catch (err) {
                console.error('Registration failed:', err);
            }
        },
        async logout() {
            await signOut(auth);
            localStorage.removeItem('auth_user_id');
            localStorage.removeItem('auth_user_token');
            this.user = null;
        },
        fetchUser() {
            this.loading = true;
            onAuthStateChanged(auth, (user) => {
                this.user = user;
                this.loading = false;
            });
        },
        getUser() {
            return this.user;
        },
        isSubscribed() {
            return this.user.isSubscribed();
        },
        initAuth() {
            const auth = getAuth()
            onAuthStateChanged(auth, (user) => {
                this.user = user
                this.loading = false
            })
        },

        async getUserToken() {
            if (this.user && this.user.getIdToken) {
                return await this.user.getIdToken();
            } else if (this.user && this.user.accessToken) {
                return this.user.accessToken;
            } else {
                console.warn('User token not available');
                return null;
            }
        },

        async getUserId() {
            if (this.user) {
                return this.user.uid;
            } else {
                console.warn('User ID not available');
                return null;
            }
        },

        async isAuthenticated() {
            return this.user !== null;
        },

        async refreshUser() {
            if (this.user) {
                await this.user.reload();
                this.user = getAuth().currentUser;
            } else {
                console.warn('No user to refresh');
            }
        },
        async refreshToken() {
            if (this.user) {
                return await this.user.getIdToken(true);
            } else {
                console.warn('No user to refresh token for');
                return null;
            }
        },

        async upgradePlan(plan = 'monthly') {
            try {
                const idToken = await this.user.getIdToken();
                const response = await fetch(import.meta.env.VITE_BACKEND_API_URL + '/api/auth/upgrade', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${idToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ plan })
                });

                const result = await response.json();
                console.log('Upgrade response:', result);
            } catch (error) {
                console.error('Upgrade failed:', error);
            }
        }
    }
});
